import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode, VNodePropertiesWithoutIndex } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicDetails } from 'lcc-state/interfaces';
import { TopicWidgetProperties } from 'book-widgets/interfaces';

interface ImageIcache {
	width: number;
}

const icache = createICacheMiddleware<ImageIcache>();
const factory = create({ icache, theme }).properties<TopicWidgetProperties>();

export const Image = factory(({ properties, middleware: { icache } }) => {
	const { topicdata } = properties();
	const data: TopicDetails = topicdata as any;
	const { attributes = { src: '#', id: '' }, children = [] } = data;
	const src = attributes.src;

	const width = icache.get('width');
	const styles = width ? { width: `${width}px`, height: 'auto' } : {};

	const alt = children
		.map((item) => {
			const key = Object.keys(item)[0];
			return item[key].children?.[0];
		})
		.join('');

	const params: VNodePropertiesWithoutIndex = { src, styles, alt };

	if (attributes.id) {
		params['aria-labelledby'] = `${attributes.id}_long_description`;
	}

	return v(
		'img',
		{
			...params,
			onload: (event) => {
				const img: HTMLImageElement = event && (event.currentTarget as HTMLImageElement);
				img && icache.set('width', img.naturalWidth);
			}
		},
		[]
	);
});
